import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Renders a private storage-backed image by fetching /api/files/{id} as a
 * blob via the axios instance — the httpOnly access_token cookie is
 * attached automatically. Cleanly handles the loading / error / no-image
 * states so callers don't have to repeat the pattern in every place we
 * show a photo.
 */
export function FileImage({ fileId, alt, className, fallback = null }) {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (!fileId) { setSrc(null); return; }
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get(`/files/${fileId}`, { responseType: "blob" });
        if (cancelled) return;
        const url = URL.createObjectURL(res.data);
        setSrc(url);
      } catch { if (!cancelled) setErr(true); }
    })();
    return () => { cancelled = true; if (src) URL.revokeObjectURL(src); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileId]);

  if (!fileId || err) return fallback;
  if (!src) return <div className={`${className} bg-muted animate-pulse`} />;
  return <img src={src} alt={alt} className={className} />;
}
